import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TGetMarginIsolatedAccountParams,
  TGetMarginIsolatedAccountResponse,
  getMarginIsolatedAccount,
  TGetMarginIsolatedAccountDetailParams,
  TGetMarginIsolatedAccountDetailResponse,
  getMarginIsolatedAccountDetail,
  TPostMarginIsolatedBorrowParams,
  TPostMarginIsolatedBorrowResponse,
  postMarginIsolatedBorrow,
  TGetMarginIsolatedBorrowRecordParams,
  TGetMarginIsolatedBorrowRecordResponse,
  getMarginIsolatedBorrowRecord,
  TGetMarginIsolatedInterestRecordParams,
  TGetMarginIsolatedInterestRecordResponse,
  getMarginIsolatedInterestRecord,
  TGetMarginIsolatedLadderParams,
  TGetMarginIsolatedLadderResponse,
  getMarginIsolatedLadder,
  TGetMarginIsolatedLiquidationDetailParams,
  TGetMarginIsolatedLiquidationDetailResponse,
  getMarginIsolatedLiquidationDetail,
  TGetMarginIsolatedLiquidationRecordParams,
  TGetMarginIsolatedLiquidationRecordResponse,
  getMarginIsolatedLiquidationRecord,
  TGetMarginIsolatedPairParams,
  TGetMarginIsolatedPairResponse,
  getMarginIsolatedPair,
  TPostMarginIsolatedRepayParams,
  TPostMarginIsolatedRepayResponse,
  postMarginIsolatedRepay,
  TGetMarginIsolatedRepayRecordParams,
  TGetMarginIsolatedRepayRecordResponse,
  getMarginIsolatedRepayRecord,
  TGetMarginIsolatedTradeTypesParams,
  TGetMarginIsolatedTradeTypesResponse,
  getMarginIsolatedTradeTypes,
  TGetMarginIsolatedTransferRecordParams,
  TGetMarginIsolatedTransferRecordResponse,
  getMarginIsolatedTransferRecord,
  TGetMarginIsolatedUserBorrowInfoParams,
  TGetMarginIsolatedUserBorrowInfoResponse,
  getMarginIsolatedUserBorrowInfo,
  TGetMarginIsolatedUserRepayInfoParams,
  TGetMarginIsolatedUserRepayInfoResponse,
  getMarginIsolatedUserRepayInfo,
  TPostMarginIsolatedClosePositionParams,
  TPostMarginIsolatedClosePositionResponse,
  postMarginIsolatedClosePosition,
  TGetMarginIsolatedMaxBorrowableParams,
  TGetMarginIsolatedMaxBorrowableResponse,
  getMarginIsolatedMaxBorrowable,
  TGetMarginIsolatedPairAssetsParams,
  TGetMarginIsolatedPairAssetsResponse,
  getMarginIsolatedPairAssets,
  TGetMarginIsolatedAssetParams,
  TGetMarginIsolatedAssetResponse,
  getMarginIsolatedAsset,
} from 'core/service/yapi/hk-web/MarginIsolated/api'
// 逐仓杠杆交易
// 逐仓杠杆总资产、负债、账户权益
export const useGetMarginIsolatedAccountQuery = (
  params?: TGetMarginIsolatedAccountParams,
  options?: TUseQueryOptions<TGetMarginIsolatedAccountResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedAccount', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedAccount(params),
  })
}

// 逐仓币对资产、负债、账户权益
export const useGetMarginIsolatedAccountDetailQuery = (
  params?: TGetMarginIsolatedAccountDetailParams,
  options?: TUseQueryOptions<TGetMarginIsolatedAccountDetailResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedAccountDetail', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedAccountDetail(params),
  })
}

// 杠杆-逐仓借款
export const usePostMarginIsolatedBorrowMutation = (
  mutationOptions?: TUseMutationOptions<TPostMarginIsolatedBorrowResponse, TPostMarginIsolatedBorrowParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['MarginIsolated', 'MarginIsolatedBorrow', 'Post'],
    mutationFn: (params?: TPostMarginIsolatedBorrowParams) => postMarginIsolatedBorrow(params),
  })
}

// 逐仓-借款记录
export const useGetMarginIsolatedBorrowRecordQuery = (
  params?: TGetMarginIsolatedBorrowRecordParams,
  options?: TUseQueryOptions<TGetMarginIsolatedBorrowRecordResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedBorrowRecord', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedBorrowRecord(params),
  })
}

// 逐仓-利息记录
export const useGetMarginIsolatedInterestRecordQuery = (
  params?: TGetMarginIsolatedInterestRecordParams,
  options?: TUseQueryOptions<TGetMarginIsolatedInterestRecordResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedInterestRecord', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedInterestRecord(params),
  })
}

// 杠杆逐仓交易对档位信息
export const useGetMarginIsolatedLadderQuery = (
  params?: TGetMarginIsolatedLadderParams,
  options?: TUseQueryOptions<TGetMarginIsolatedLadderResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedLadder', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedLadder(params),
  })
}

// 逐仓-强平订单
export const useGetMarginIsolatedLiquidationDetailQuery = (
  params?: TGetMarginIsolatedLiquidationDetailParams,
  options?: TUseQueryOptions<TGetMarginIsolatedLiquidationDetailResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedLiquidationDetail', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedLiquidationDetail(params),
  })
}

// 逐仓-强平记录
export const useGetMarginIsolatedLiquidationRecordQuery = (
  params?: TGetMarginIsolatedLiquidationRecordParams,
  options?: TUseQueryOptions<TGetMarginIsolatedLiquidationRecordResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedLiquidationRecord', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedLiquidationRecord(params),
  })
}

// 杠杆逐仓交易对信息
export const useGetMarginIsolatedPairQuery = (
  params?: TGetMarginIsolatedPairParams,
  options?: TUseQueryOptions<TGetMarginIsolatedPairResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedPair', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedPair(params),
  })
}

// 杠杆-逐仓还款
export const usePostMarginIsolatedRepayMutation = (
  mutationOptions?: TUseMutationOptions<TPostMarginIsolatedRepayResponse, TPostMarginIsolatedRepayParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['MarginIsolated', 'MarginIsolatedRepay', 'Post'],
    mutationFn: (params?: TPostMarginIsolatedRepayParams) => postMarginIsolatedRepay(params),
  })
}

// 逐仓-还款记录
export const useGetMarginIsolatedRepayRecordQuery = (
  params?: TGetMarginIsolatedRepayRecordParams,
  options?: TUseQueryOptions<TGetMarginIsolatedRepayRecordResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedRepayRecord', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedRepayRecord(params),
  })
}

// 逐仓交易对
export const useGetMarginIsolatedTradeTypesQuery = (
  params?: TGetMarginIsolatedTradeTypesParams,
  options?: TUseQueryOptions<TGetMarginIsolatedTradeTypesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedTradeTypes', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedTradeTypes(params),
  })
}

// 逐仓-划转记录
export const useGetMarginIsolatedTransferRecordQuery = (
  params?: TGetMarginIsolatedTransferRecordParams,
  options?: TUseQueryOptions<TGetMarginIsolatedTransferRecordResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedTransferRecord', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedTransferRecord(params),
  })
}

// 逐仓借款--前置查询
export const useGetMarginIsolatedUserBorrowInfoQuery = (
  params?: TGetMarginIsolatedUserBorrowInfoParams,
  options?: TUseQueryOptions<TGetMarginIsolatedUserBorrowInfoResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedUserBorrowInfo', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedUserBorrowInfo(params),
  })
}

// 逐仓还款--前置查询
export const useGetMarginIsolatedUserRepayInfoQuery = (
  params?: TGetMarginIsolatedUserRepayInfoParams,
  options?: TUseQueryOptions<TGetMarginIsolatedUserRepayInfoResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedUserRepayInfo', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedUserRepayInfo(params),
  })
}

// 杠杆-平仓
export const usePostMarginIsolatedClosePositionMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostMarginIsolatedClosePositionResponse,
    TPostMarginIsolatedClosePositionParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['MarginIsolated', 'MarginIsolatedClosePosition', 'Post'],
    mutationFn: (params?: TPostMarginIsolatedClosePositionParams) => postMarginIsolatedClosePosition(params),
  })
}

// 查询杠杆逐仓资产最大可借
export const useGetMarginIsolatedMaxBorrowableQuery = (
  params?: TGetMarginIsolatedMaxBorrowableParams,
  options?: TUseQueryOptions<TGetMarginIsolatedMaxBorrowableResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedMaxBorrowable', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedMaxBorrowable(params),
  })
}

// 根据交易对查询杠杆用户资产
export const useGetMarginIsolatedPairAssetsQuery = (
  params?: TGetMarginIsolatedPairAssetsParams,
  options?: TUseQueryOptions<TGetMarginIsolatedPairAssetsResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedPairAssets', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedPairAssets(params),
  })
}

// 逐仓杠杆总资产、负债、账户权益，与资产推送保持一致
export const useGetMarginIsolatedAssetQuery = (
  params?: TGetMarginIsolatedAssetParams,
  options?: TUseQueryOptions<TGetMarginIsolatedAssetResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarginIsolated', 'MarginIsolatedAsset', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarginIsolatedAsset(params),
  })
}
